import { render } from "./AccountOption.vue?vue&type=template&id=bfa8aa3e&scoped=true"
import script from "./AccountOption.vue?vue&type=script&lang=js"
export * from "./AccountOption.vue?vue&type=script&lang=js"

import "./AccountOption.vue?vue&type=style&index=0&id=bfa8aa3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa8aa3e"]])

export default __exports__